import Api_Usermanagement from '../../api-usermanagement'
const api = new Api_Usermanagement().init()

const downloadTemplate = () => {
    return api.get('/users/export-template-excel', {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

const importUser = (data, lang) => {
    return api.post(`/users/import?lang=${lang}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

export { downloadTemplate, importUser }